
/*
*****************************************************************************
*File : api-response.js
*Module : Dashboard Frontend
*Purpose :Draws the train in a given section
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
*/

import store from "../../store"
import router from '@/router'
export default new class ApiResponse {

  checkErrorCode(statusCode) {
    if(statusCode === 401) {
        window.localStorage.setItem("isTokenExpired" , true)       
        window.localStorage.removeItem('vuex')        
        if(window.localStorage.getItem('vuex')==undefined) {          
          window.localStorage.setItem('loggedInUser', false)
        }
    }

  } /*end function */
}